import { useIsAuthenticated } from 'src/auth/firebaseMsalCompat';

import { MAX_IMAGE_PAGES } from './useFingeringUpload';
import { useSubscriptionStatus } from './useSubscriptionStatus';

/**
 * Max page images in one OMR bundle.
 *
 * Full {@link MAX_IMAGE_PAGES} when monthly + extra credits > 0; otherwise 1.
 * An unknown balance (null status) is not zero — keep the full bundle and let
 * the backend enforce the real limit.
 */
export function useImagePageLimit(): number {
  const isAuthenticated = useIsAuthenticated();
  const { subscriptionStatus } = useSubscriptionStatus(isAuthenticated);
  if (subscriptionStatus === null) return MAX_IMAGE_PAGES;
  const totalCredits =
    (subscriptionStatus.creditBalance ?? 0) +
    (subscriptionStatus.extraCredits ?? 0);
  return totalCredits > 0 ? MAX_IMAGE_PAGES : 1;
}
